export default "__VITE_ASSET__CfNGwpDP__"